<template>
  <span>
    <slot :color="color" :is-saved="isSaved" :is-saving="isSaving" :needs-save="needsSave" :stop="stop" >
    </slot>
  </span>
</template>
<script>
import { debounce } from 'quasar'
import colors from '../../mixins/colors'
export default {
  mixins: [colors],
  name: 'AutoSaver',
  props: {
    dBounce: {
      type: Function,
      default: async () => {}
    },
    duration: {
      type: Number,
      default: () => 2000
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      debouncedFunction: null,
      needsSave: false,
      saveError: false,
      isSaving: false,
      isSaved: false,
      shouldStop: false
    }
  },
  methods: {
    handleSave () {
      this.needsSave = true
      if (this.dBounce) {
        this.debouncedFunction()
      }
    },
    stop () {
      this.shouldStop = true
    }
  },
  computed: {
    color () {
      if (this.disabled) {
        return 'grey-4'
      }
      if (this.saveError) {
        return 'negative'
      }
      if (this.needsSave) {
        return this.inputBgColor
      }
      if (this.isSaved) {
        return this.inputBgColor2
      }
      return this.value ? this.inputBgColor2 : this.inputBgColor
    },
    textClass () {
      if (this.disabled) {
        return 'grey-7'
      }
      if (this.saveError) {
        return 'text-white'
      }
      if (this.needsSave) {
        return 'text-primary'
      }
      if (this.isSaved) {
        return 'text-white'
      }
      return this.value ? this.inputBgColor2 : this.inputBgColor
    }
  },
  mounted () {
    this.debouncedFunction = debounce(async () => {
      if (!this.dBounce) {
        return
      }
      if (this.shouldStop) {
        this.shouldStop = false
        return
      }
      try {
        this.isSaving = true
        this.saveError = false
        await this.dBounce(this.value, this.params)
        this.$nextTick(() => {
          this.isSaving = false
          this.needsSave = false
          this.isSaved = true
        })
      } catch (e) {
        this.isSaving = false
        this.needsSave = true
        // this.saveError = true
      }
    }, this.duration)
  },
  watch: {
    value () {
      this.handleSave()
    }
  }
}
</script>
